<template>
  <div class="box2">
    <div class="previewImage" v-if="isPreview" @click="close">
      <img :src="imageUrl" alt />
    </div>
    <pageTitle title="为什么要认证阿里云ACP" titleColor="#332114" />
    <div class="acp-stitle stit-1">
      <span>ACP认证的必要性</span>
    </div>
    <ul class="info-list">
      <li v-for="(item, index) in list" :key="index">
        <div class="top" @click="open(item)">
          <img :src="item.icon" alt="" />
          <span>{{ item.title }}</span>
          <div class="open-btn" :class="{ active: item.flag }"></div>
        </div>
        <div class="bottom" v-show="item.flag">
          <div
            class="bottomInner"
            v-html="item.info[0]"
            v-if="index != 3"
          ></div>
          <div class="bottomInner" v-else>
            <h2>阿里云招聘岗位明确【持证者优先】它是迈进大厂的刚需证书</h2>
            <ul>
              <li>
                <img
                  @click="
                    previewImage(
                      require('../../../assets/coursePage/acp/box2/img02.png')
                    )
                  "
                  class="little"
                  src="../../../assets/coursePage/acp/box2/img02.png"
                />
              </li>
              <li>
                <img
                  @click="
                    previewImage(
                      require('../../../assets/coursePage/acp/box2/img03.png')
                    )
                  "
                  class="little"
                  src="../../../assets/coursePage/acp/box2/img03.png"
                />
              </li>
              <li>
                <img
                  @click="
                    previewImage(
                      require('../../../assets/coursePage/acp/box2/img04.jpg')
                    )
                  "
                  class="little"
                  src="../../../assets/coursePage/acp/box2/img04.jpg"
                />
              </li>
            </ul>
            <p>
              <em>* 阿里云为80%中国科技创新企业提供云服务，所有阿里云生态体系公司要求持证上岗，平均每个公司要求8个持证人员。</em>
              <em>* 很多招标项目会对服务团队技术人员作出要求，拥有ACP证书更有助于赢得雇主、客户的信任。</em>
            </p>
          </div>
        </div>
      </li>
    </ul>
    <div class="acp-stitle stit-2">
      <span>阿里云强大的实力 </span>
    </div>
    <div class="cloud">
      <h1>阿里云-国内排行第一的公有云</h1>
      <img src="../../../assets/coursePage/acp/box2/img05.png" />
      <p>
        来源：IDC中国，2023年4月23日，IDC发布了《中国公有云服务市场（2022下半年）跟踪》报告，调查显示阿里云、华为云、中国电信天翼云、腾讯云和AWS为市场排名前五位，阿里云公有云市场份额达到32.6%，位居行业第一，占据绝对性优势。
      </p>
    </div>
    <div class="cloud">
      <h1>ACP：阿里云专业认证</h1>
      <img src="../../../assets/coursePage/acp/box2/img06.png" />
      <p>
        阿里云ACP认证（Alibaba Cloud Certified
        Professional）是面向阿里云核心产品技术领域如云计算、大数据、人工智能等的专业技术认证。越来越的企业明确要求持ACP认证者优先，ACP考证人数越来越多，通过率也最高。
      </p>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },

  data() {
    return {
      isPreview: false,
      imageUrl: null,
      list: [
        {
          icon: require("../../../assets/coursePage/acp/box2/icon-01.png"),
          title: "各类企业已经逐步上云",
          info: [
            `<img src=${require("../../../assets/coursePage/acp/box2/img01.png")} /><p>除此之外，智慧司法&农业&交管、音视频智能媒资管理、数字证券、体育文化、医院互联网安全等，各类企业/行业都已逐步部署云服务。</p>`,
          ],
          flag: false,
        },
        {
          icon: require("../../../assets/coursePage/acp/box2/icon-02.png"),
          title: "行业认可，专业度高",
          info: [
            `<h2>阿里云认证是国内技术人才市场认可度较高的技术认证之一，是大数据人才的一种凭证。</h2>
            <p>取得阿里云ACP认证，能够证明您在阿里云上设计、部署或管理应用程序和基础设施等相关技术领域是具备广泛知识和实践经验的，有助于证明您使用阿里云产品的丰富经验和可信度。</p>`,
          ],
          flag: false,
        },
        {
          icon: require("../../../assets/coursePage/acp/box2/icon-03.png"),
          title: "提升技术实力 ",
          info: [
            `<h2>通过ACP认证考试，你将：</h2>
           <p>
            <em>1. 了解大数据开发的整个流程并可以将阿里云大数据产品应用到流程中；</em>
            <em>2. 能熟练使用阿里云的大数据计算服务 MaxCompute、数据工场DataWorks、数据集成、QuickBI 以及机器学习 PAI 等产品；</em>
            <em>3. 具备大数据集成、存储、处理、分析以及展现的基础知识；</em>
            <em>4. 能根据企业业务需求，基于阿里云的大数据产品制定有效的技术解决方案。</em>
            </p>`,
          ],
          flag: false,
        },
        {
          icon: require("../../../assets/coursePage/acp/box2/icon-04.png"),
          title: "迎合招聘需求",
          
          flag: false,
        },
      ],
    };
  },
  methods: {
    open(item) {
      this.list.forEach((val) => {
        if (item.title === val.title) {
          val.flag = !val.flag;
        } else {
          val.flag = false;
        }
      });
    },
    close() {
      this.isPreview = false;
      this.imageUrl = "";
    },
    previewImage(url) {
      this.imageUrl = url;
      this.isPreview = true;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.box2 {
  background-image: url(../../../assets/coursePage/acp/box2/bg.png);
  background-size: 100% 100%;
  padding: 80px 32px 88px;
  .previewImage {
    position: fixed;
    top: 0px;
    display: flex;
    align-items: center;

    height: 100%;
    background: #000;
    z-index: 200;
    img {
      width: 100%;
      margin: 0 auto;
    }
  }
  .cloud {
    width: 100%;

    background-color: #ffffff;
    box-shadow: 0px 20px 30px 0px #fff0e0;
    border-radius: 20px;
    border: solid 2px #ffe5cc;
    padding: 40px;
    box-sizing: border-box;
    margin: 30px auto;
    h1 {
      font-family: PingFangSC-Medium;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 38px;
      letter-spacing: 0px;
      color: #332114;
      text-align: center;
    }
    img {
      width: 100%;
      margin: 55px 0;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: #99877a;
    }
  }
  .stit-1 {
    &:after {
      width: 312px;
    }
  }
  .stit-2 {
    margin-top: 80px;
    &:after {
      width: 228px;
    }
  }
  .info-list {
    margin-top: 50px;
    > li {
      background-image: linear-gradient(
        45deg,
        #fff6f0 0%,
        #fffcfa 50%,
        #fff6f0 100%
      );
      border-radius: 20px;
      border: solid 2px #ffc399;
      margin-bottom: 24px;
      .top {
        padding: 24px 32px 24px 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 64px;
          height: 64px;
        }
        span {
          flex: 1;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #24375c;
          line-height: 64px;
          padding-left: 32px;
        }
        .open-btn {
          width: 24px;
          height: 14px;
          background: url(../../../assets/coursePage/acp/box2/icon-down.png);
          background-size: 100% 100%;
          &.active {
            transform: rotate(180deg);
          }
        }
      }
      .bottom {
        padding: 0 40px 40px;
        ::v-deep {
          .bottomInner {
            > img {
              width: 100%;
              margin-bottom: 28px;
            }
            h2 {
              font-family: PingFangSC-Medium;
              font-size: 26px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 36px;
              letter-spacing: 0px;
              color: #4d3926;
              margin-bottom: 27px;
            }
            p {
              font-family: PingFangSC-Regular;
              font-size: 24px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 36px;
              letter-spacing: 1px;
              color: #4d3926;
              em{
                font-style: normal;
                text-indent: -20px;
                padding-left: 20px;
                display: block;
              }
            }
            ul {
              display: flex;
              justify-content: space-between;
              margin-bottom: 28px;
              li {
                width: 190px;
                img {
                  width: 100%;
                  border-radius: 10px;
                }
              }
            }
          }
        }
        p {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #425a7c;
          line-height: 44px;
          margin-bottom: 24px;
        }
        p:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .info-list {
    > li:nth-child(3) {
      .bottom {
        ::v-deep {
          .bottomInner {
            p {
              em {
                font-style: normal;
                text-indent: -28px;
                padding-left: 28px;
                display: block;
              }
            }
          }
        }
      }
    }
  }
  .text-list-mask {
    margin-top: 48px;
    overflow-x: auto;
    overflow-y: hidden;
    height: 136px;
    margin-left: -32px;
    width: 750px;
    .text-list {
      max-width: 828px;
      height: 176px;
      display: flex;
      padding: 0 32px 40px;
      overflow-x: auto;
      overflow-y: hidden;
      box-sizing: border-box;
      > div {
        width: 260px;
        min-width: 260px;
        height: 136px;
        padding: 24px 0 24px 32px;
        background: url(../../../assets/coursePage/fcp/box2/card-bg.png);
        background-size: 260px 136px;
        background-repeat: no-repeat;
        margin-right: 24px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #24375c;
        line-height: 44px;
        box-sizing: border-box;
        &:last-child {
          margin: 0;
        }
      }
    }
  }
}
</style>